import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { SkillProfile } from "@app/models/rest/skill-profile";
import { SkillProfileRestService } from "@app/services/hal/skill-profile-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class SkillProfileStore extends RealTimeDataStore<SkillProfile> {
  constructor() {
    const skillProfileRestService = inject(SkillProfileRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(skillProfileRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("SkillProfile");
  }
}
